import {
  ISearchOffersForHouseCardDesktopOptions,
  TSearchOffersForHouseCardDesktopResponse_1,
  ISearchOffersForHouseCardDesktopResponse200,
  ISearchOffersForHouseCardDesktopResponse400,
  TSearchOffersForHouseCardDesktopResponseError,
  fetchSearchOffersForHouseCardDesktop,
} from 'shared/repositories/search-offers/v1/search-offers-for-house-card-desktop';
import { EOffersStatus, IOffersDesktop, IOffersState } from 'shared/types/offers';
import { assertResponseError } from 'shared/utils/errors';
import { request } from 'shared/utils/request';
import { prepareDesktopOffers } from 'shared/mappers/offers';
import { IJsonQuery } from '../../../packages/JsonQuery';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';
import { IApplicationContext } from 'shared/types/applicationContext';
import { initialState } from 'shared/slices/offers/initialState';

type TParameters = TRequestParamsWithoutHttpApi<
  ISearchOffersForHouseCardDesktopOptions<
    ISearchOffersForHouseCardDesktopResponse200,
    ISearchOffersForHouseCardDesktopResponse400
  >
>;

export const fetchOffersDesktop = (context: IApplicationContext, parameters: TParameters) =>
  request<
    IOffersState<IOffersDesktop>,
    TParameters,
    TSearchOffersForHouseCardDesktopResponse_1,
    TSearchOffersForHouseCardDesktopResponseError
  >(context, {
    parameters,
    domain: 'fetchOffersDesktop',
    fetchFunction: fetchSearchOffersForHouseCardDesktop,
    errorHandler: assertResponseError,
    prepareFunction: prepareDesktopOffers,
    defaultValue: {
      data: {
        jsonQuery: {
          _type: 'flatsale',
          geo: { type: 'geo', value: [{ type: 'house', id: parameters.parameters.houseId }] },
        } as IJsonQuery,
        offers: [],
        counters: initialState.data.counters,
      },
      status: EOffersStatus.Failed,
    },
  });
